// extracted by mini-css-extract-plugin
export default {"home_appeal":"App_home_appeal__iWgkX","browser_not_available":"App_browser_not_available__FSjke"};